// Remembers the picked camera across the page reload a video provider reconnects triggers,
// so we can re-select it instead of default. localStorage outlives the reload.
const CAMERA_DEVICE_ID_KEY = 'selectedCameraDeviceId';

// Twilio `video` connect option: true = default camera, or a pinned device.
type PreferredVideoInput = boolean | { deviceId: { exact: string } };

export function saveCameraDeviceId(deviceId: string): void {
  try {
    if (deviceId) localStorage.setItem(CAMERA_DEVICE_ID_KEY, deviceId);
  } catch (error) {
    console.warn('[cameraPreference] Failed to save camera deviceId', error);
  }
}

function getSavedCameraDeviceId(): string | null {
  try {
    return localStorage.getItem(CAMERA_DEVICE_ID_KEY);
  } catch {
    return null;
  }
}

// `video` option for `Video.connect`: the saved camera if it still exists, else
// default (`true`) — guarding against `{ exact }` failing with OverconstrainedError.
export async function getPreferredVideoInput(): Promise<PreferredVideoInput> {
  const savedId = getSavedCameraDeviceId();
  if (!savedId) return true;

  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const stillExists = devices.some((d) => d.kind === 'videoinput' && d.deviceId === savedId);
    return stillExists ? { deviceId: { exact: savedId } } : true;
  } catch {
    return true;
  }
}
